import { render, staticRenderFns } from "./ExcursionsPage.vue?vue&type=template&id=5a66f43a&"
import script from "./ExcursionsPage.vue?vue&type=script&lang=ts&"
export * from "./ExcursionsPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports